import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { UserEngineerDto } from "../../../../shared/models/User/user-engineer.dto";
import { IPlanningDayButtonContext } from "../../../../shared/components/planning-day-button/planning-day-button.component";
import { AppService } from "../../../../app.service";
import { PlanningService } from "../../../../shared/services/planning.service";
import { PlanningDayStatusRequest } from "../../../../shared/models/planning/planning-day-status-request";
import { EngubatorEngineersService } from "../../../../shared/services/engubator/engubator.engineers.service";
import { RoleEnum } from "../../../../shared/enums/role.enum";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { NotificationService } from "../../../../core/services/notification.service";
import { AlgoritmType } from "../../../../constants/planning.constants";
import { NotificationType } from "../../../../core/services/notification-type";
import { Subject } from "rxjs";

interface IPlanningMapVisitDayStatus {
    time: string;
    performerIntegraCode: string;
    isAvailable: boolean;
    loading: boolean;
    isDefault: boolean;
    isSuccessful: boolean;
    errorDescription: string;
}

export class IPlanningMapVisitContext {
    performerIntegraCode: string;
    visitDate: Date;
    removeActivityTracking: boolean;
    algoritmType: string;
}

@Component({
    selector: 'planning-map-visit',
    templateUrl: './planning-map-visit.component.html',
    styleUrls: [
        './planning-map-visit.component.scss',
    ],
})
export class PlanningMapVisitComponent implements OnInit {

    @Input() visitDate: Date;
    @Input() requestId: number;
    @Input() requestServiceCenterId: number;
    @Input() requestIntegraCode: string;
    @Input() availablePerformers: KeyValueObject[] = [];
    @Input() selectedPerformerIntegraCode: string;
    @Input() requestServiceCenterIntegraCode: string;

    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onContinueEvent: EventEmitter<IPlanningMapVisitContext> = new EventEmitter<IPlanningMapVisitContext>();

    dayStatuses: IPlanningMapVisitDayStatus[] = [];
    timeControlValue: Date;
    time: string;

    contentLoaded: boolean = false;
    dayOfWeekName: string;
    monthName: string;
    dayNumber: number;
    dataSaving: boolean;
    algoritmType: string;
    removeActivityTracking: boolean = false;

    constructor(
        private appService: AppService,
        private planningService: PlanningService,
        private engubatorEngineersService: EngubatorEngineersService,
        private notificationService: NotificationService
    ) { }

    ngOnInit(): void {
        this.engubatorEngineersService.getAvailablePerformers(this.requestIntegraCode, [<number>RoleEnum.master, <number>RoleEnum.specialist], this.requestServiceCenterIntegraCode).subscribe(resp => {
            this.availablePerformers = resp.data.map(x => {
                let item = new KeyValueObject(x.userId, x.fullName);
                item.integraCode = x.integraCode;
                return item;
            });

            this.dayOfWeekName = this.appService.getDayOfWeekName(this.visitDate);
            this.monthName = this.appService.getMonthName(this.visitDate, false);
            this.dayNumber = this.visitDate.getDate();
            this.time = `${this.visitDate.getHours()}:${this.visitDate.getMinutes()}`;
            this.timeControlValue = new Date(this.visitDate);

            let status = {
                time: this.time,
                performerIntegraCode: this.selectedPerformerIntegraCode,
                loading: false,
                isAvailable: true,
                isDefault: true
            } as IPlanningMapVisitDayStatus;

            this.dayStatuses.push(status);
            this.contentLoaded = true;
        });
    }

    changeAlgoritmType(algoritmType: string): void {
        this.algoritmType = algoritmType;
    }

    performerChange(event: any) {
        this.checkDayStatus();
    }

    timeChange(event: Date) {
        this.time = event != null
            ? `${event.getHours()}:${event.getMinutes()}`
            : null;

        this.checkDayStatus();
    }

    checkDayStatus() {
        if (this.currentDayStatus == null) {
            this.planningService.getAlgoritmType().subscribe(res => {
                if (res) {
                    this.changeAlgoritmType(res);
                }

                let status = {
                    time: this.time,
                    performerIntegraCode: this.selectedPerformerIntegraCode,
                    loading: true
                } as IPlanningMapVisitDayStatus;

                this.dayStatuses.push(status);

                let dayStatusModel = {
                    requestId: this.requestId,
                    requestIntegraCode: this.requestIntegraCode,
                    performerIntegraCode: this.selectedPerformerIntegraCode,
                    visitDate: this.visitDate,
                    time: this.time,
                    serviceCenterId: this.requestServiceCenterId,
                    algoritmType: this.algoritmType,
                } as PlanningDayStatusRequest;

                let manualAction = () => {
                    this.changeAlgoritmType(AlgoritmType.manual);
                    dayStatusModel.algoritmType = this.algoritmType;
                    let cancelCheckDayStatusManualAction$ = new Subject<void>();
                    this.planningService.checkDayStatus(dayStatusModel, true, cancelCheckDayStatusManualAction$).subscribe(respAlt => {
                        status.loading = false;

                        if (respAlt.isSuccessful) {
                            status.isAvailable = respAlt.data.dayAvailable && respAlt.data.isSuccessful;
                            status.isSuccessful = respAlt.data.isSuccessful;
                            status.errorDescription = respAlt.data.errorDescription;
                            this.removeActivityTracking = true;
                            this.notifyIfDayUnavailable(respAlt.data);
                        } else {
                            status.isAvailable = false;
                            status.isSuccessful = false;
                            status.errorDescription = respAlt.data.errorDescription;
                        }
                    }, (err) => {
                        status.loading = false;
                        status.isAvailable = false;
                        status.isSuccessful = false;
                        status.errorDescription = err;
                        cancelCheckDayStatusManualAction$.next();
                    });
                };

                let cancelCheckDayStatus$ = new Subject<void>();
                this.planningService.checkDayStatus(dayStatusModel, this.algoritmType === AlgoritmType.manual, cancelCheckDayStatus$).subscribe((resp) => {
                    status.loading = false;

                    if (resp.isSuccessful) {
                        status.isAvailable = resp.data.dayAvailable && resp.data.isSuccessful;
                        status.isSuccessful = resp.data.isSuccessful;
                        status.errorDescription = resp.data.errorDescription;
                        this.notifyIfDayUnavailable(resp.data);
                    } else if (this.algoritmType === AlgoritmType.yandex) {
                        this.notificationService.error({
                            title: 'Ошибка',
                            message: 'Произошел сбой в сервисе маршрутизации. Переключаем на мануальный режим планирования',
                            notificationType: NotificationType.SweetAlert
                        }, manualAction, manualAction, manualAction);
                    }
                }, () => {
                    this.notificationService.error({
                        title: 'Ошибка',
                        message: 'Произошел сбой в сервисе маршрутизации. Переключаем на мануальный режим планирования',
                        notificationType: NotificationType.SweetAlert
                    }, manualAction, manualAction, manualAction);
                    cancelCheckDayStatus$.next();
                });
            });
        }
    }

    cancel() {
        this.onCancelEvent.emit();
    }

    continue() {
        if (!this.currentDayStatus.isSuccessful) {
            this.notificationService.error({
                title: 'Ошибка',
                message: this.currentDayStatus.errorDescription,
                notificationType: NotificationType.SweetAlert
            });

            return;
        }

        if (this.currentDayStatus.isAvailable) {
            this.continueCore();
        }
        else {
            this.notificationService.confirmation({
                title: 'Предупреждение',
                message: 'Вы уверены, что хотите выбрать этот день для перепланирования?',
                showCancelButton: true,
                showConfirmButton: true,
                cancelButtonText: 'Отменить',
                confirmButtonText: 'Подтвердить'
            }, () => { this.continueCore() }, () => { });
        }
    }

    continueCore() {
        let visitContext = {
            performerIntegraCode: this.selectedPerformerIntegraCode,
            visitDate: this.getCompleteDate(),
            removeActivityTracking: this.removeActivityTracking,
            algoritmType: this.algoritmType
        } as IPlanningMapVisitContext;

        this.dataSaving = true;
        this.onContinueEvent.emit(visitContext);
    }

    getCompleteDate(): Date {
        const [hours, minutes] = this.time != null
            ? this.time.split(':').map(Number)
            : [0, 0];

        let date = new Date(
            this.visitDate.getFullYear(),
            this.visitDate.getMonth(),
            this.visitDate.getDate(),
            hours,
            minutes
        );

        return date;
    }

    get dayContext(): IPlanningDayButtonContext {
        let currentDayStatus = this.currentDayStatus;

        return {
            isSelected: false,
            isCompletly: !currentDayStatus.loading,
            statusLoading: currentDayStatus.loading,
            statusAvailable: currentDayStatus.isAvailable,
            hasStatus: true
        } as IPlanningDayButtonContext;
    }

    private notifyIfDayUnavailable(data: { dayAvailable: boolean; isSuccessful: boolean; unavailabilityReason: string }): void {
        if (!data || data.isSuccessful === false || data.dayAvailable !== false || !data.unavailabilityReason) {
            return;
        }

        this.notificationService.warning({
            title: 'Планирование недоступно',
            message: data.unavailabilityReason,
            notificationType: NotificationType.Toast
        });
    }

    get currentDayStatus(): IPlanningMapVisitDayStatus {
        return this.dayStatuses.find(x => x.time == this.time && x.performerIntegraCode == this.selectedPerformerIntegraCode);
    }

    get canComplete(): boolean {
        return this.currentDayStatus != null && !this.currentDayStatus.loading && !this.currentDayStatus.isDefault;
    }
}